import { render, staticRenderFns } from "./SprintWorkItemGantt.vue?vue&type=template&id=21c95c87&scoped=true&"
import script from "./SprintWorkItemGantt.vue?vue&type=script&lang=js&"
export * from "./SprintWorkItemGantt.vue?vue&type=script&lang=js&"
import style0 from "./SprintWorkItemGantt.vue?vue&type=style&index=0&id=21c95c87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c95c87",
  null
  
)

export default component.exports